import { render, staticRenderFns } from "./MediaDropZone.vue?vue&type=template&id=5bcbdaff&scoped=true&"
import script from "./MediaDropZone.vue?vue&type=script&lang=js&"
export * from "./MediaDropZone.vue?vue&type=script&lang=js&"
import style0 from "./MediaDropZone.vue?vue&type=style&index=0&id=5bcbdaff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbdaff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
